import { render, staticRenderFns } from "./app_list.vue?vue&type=template&id=25a1153d"
import script from "./app_list.vue?vue&type=script&lang=js"
export * from "./app_list.vue?vue&type=script&lang=js"
import style0 from "./app_list.vue?vue&type=style&index=0&id=25a1153d&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6_es6nbxkbffq4rffv33bwkugdri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bluetooth-light-web\\node_modules\\.pnpm\\registry.npmmirror.com+vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25a1153d')) {
      api.createRecord('25a1153d', component.options)
    } else {
      api.reload('25a1153d', component.options)
    }
    module.hot.accept("./app_list.vue?vue&type=template&id=25a1153d", function () {
      api.rerender('25a1153d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Other/feedback/app_list.vue"
export default component.exports